export const formataPreço = (preço) => {

  const preçoDividido = preço.split(',')

  if (preçoDividido.length > 1) {

    let decimal = preçoDividido[1].length > 1 ? preçoDividido[1] : preçoDividido[1] += '0'

    return formataCasaDecimal(preçoDividido[0]) + ',' + decimal

  } else {

    return formataCasaDecimal(preçoDividido[0]) + ',00'

  }
}

const formataCasaDecimal = (preço) => {

  // for example, if preço has 4 digits, it should be 1.234. If it has 5 digits, it should be 12.345. If it has 6 digits, it should be 123.456. And so on.

  let preçoFormatado = ''

  let i = 0

  for (let j = preço.length - 1; j >= 0; j--) {

    if (i === 3) {

      preçoFormatado = '.' + preçoFormatado

      i = 0

    }

    preçoFormatado = preço[j] + preçoFormatado

    i++

  }

  return preçoFormatado

}